import "./styles.css";

import { Button, Col, Form, Image, Input, Row } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch } from "../../app/hooks";
import { authAsync } from "../../features/auth/authSlice";
import { MowiLogo } from "../../shared/constants/Images";
import {
  AdminTypeId,
  OperatorTypeId,
  SuperAdminTypeId,
} from "../../shared/constants/Resources";
import { WebRoutes } from "../../shared/constants/WebRoutes";
import { selectCurrentAdminType } from "../../utils/helpers/selectorHelper";
import ContainerLayout from "../common/containerLayout";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleLogin = async (values: any) => {
    const { email, password } = values;
    setIsLoading(true);
    try {
      await dispatch(authAsync({ email, password })).then((res: any) => {
        const adminTypeId: number = selectCurrentAdminType();

        if (
          adminTypeId === SuperAdminTypeId ||
          adminTypeId === OperatorTypeId
        ) {
          return navigate(WebRoutes.TripListRoute, {
            replace: true,
          });
        }

        if (adminTypeId === AdminTypeId) {
          return navigate(WebRoutes.IndexAdminPanel, {
            replace: true,
          });
        }
      });
    } catch (e: any) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ContainerLayout showNotification={false} defaultContainer={false}>
      <Row justify="center">
        <Col
          span={6}
          style={{
            height: "94.3vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            overflowY: "hidden",
          }}
        >
          <Form
            onFinish={handleLogin}
            form={form}
            initialValues={{
              email: "",
              password: "",
            }}
          >
            <Form.Item>
              <Row justify="center">
                <Image src={MowiLogo} height={50} preview={false} />
              </Row>
            </Form.Item>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Ingrese un correo" }]}
            >
              <Input type="text" placeholder="correo" />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: "Ingrese una contraseña" }]}
            >
              <Input type="password" placeholder="contraseña" />
            </Form.Item>
            <Form.Item>
              <Row justify="center">
                <Button
                  type="link"
                  onClick={() => navigate(WebRoutes.ForgotPasswordRoute)}
                >
                  ¿Olvidaste tu contraseña?
                </Button>
              </Row>
            </Form.Item>
            <Form.Item>
              <Row justify="center">
                <Button type="primary" htmlType="submit" loading={isLoading}>
                  Ingresar
                </Button>
              </Row>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </ContainerLayout>
  );
};

export default Login;
